import React from 'react'
import ReactDOM from 'react-dom'
import ErrorBoundary from 'components/ErrorBoundary'
import { App } from './App'

// estilos y librerias
import 'admin-lte/dist/css/adminlte.min.css'
import 'admin-lte/dist/js/adminlte.min.js'
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import 'antd/dist/antd.css'
import './configs/antdConfig.js'
import 'react-toastify/dist/ReactToastify.css'
import './index.css'

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
)